exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._12PdDPuE1VFpnWMzJE6iSr{font-size:14px}html[dir] ._12PdDPuE1VFpnWMzJE6iSr{border-bottom:1px solid var(--neutralLight);margin-bottom:4px;margin-top:10px;padding-bottom:8px}html[dir=ltr] ._12PdDPuE1VFpnWMzJE6iSr{margin-left:-12px;margin-right:-24px;padding-left:12px}html[dir=rtl] ._12PdDPuE1VFpnWMzJE6iSr{margin-right:-12px;margin-left:-24px;padding-right:12px}", ""]);
// Exports
exports.locals = {
	"spellerLabel": "_12PdDPuE1VFpnWMzJE6iSr"
};